import { createContext, useContext, useState } from 'react';

const AddressContext = createContext();

export function AddressProvider({ children }) {
  const [addressData, setAddressData] = useState(null);
  const [isTKWAY, setIsTKWAY] = useState(false);

  return (
    <AddressContext.Provider value={{ addressData, setAddressData, isTKWAY, setIsTKWAY }}>
      {children}
    </AddressContext.Provider>
  );
}

export function useAddress() {
  return useContext(AddressContext);
}